/**
 * Author: Agent
 * Generation: Micro map helpers
 * Version: v3.0.1
 * Modified: 2025-11-07
 * One-liner: Ensure overlays include forest and mountain
 */

export type BaseTerrain = 'PLAIN'|'WATER'|'SAND';
export type OverlayTerrain = 'NONE'|'FOREST01'|'FOREST02'|'MOUNTAIN'|'BUILDING01'|'BUILDING02'|'FENCE';

/** Ensure at least one FOREST(01/02) and one MOUNTAIN exist on passable tiles */
export function ensureForestAndMountain(base: BaseTerrain[][], overlay: OverlayTerrain[][], seed: number = Date.now()): OverlayTerrain[][] {
  const H = overlay.length, W = overlay[0]?.length || 0;
  const out = overlay.map(r => r.slice());
  const flat = out.flat();
  const hasMountain = flat.includes('MOUNTAIN');
  const hasForest = flat.includes('FOREST01') || flat.includes('FOREST02');
  if (hasMountain && hasForest) return out;

  // simple seeded rng
  let s = seed >>> 0;
  const rnd = () => (s = (s * 1664525 + 1013904223) >>> 0) / 0xffffffff;
  const passable = (x:number,y:number) => base[y][x] !== 'WATER' && out[y][x] !== 'MOUNTAIN';

  if (!hasMountain) {
    for (let tries=0; tries<100; tries++) {
      const x = Math.floor(rnd()*W), y = Math.floor(rnd()*H);
      if (base[y][x] !== 'WATER' && base[y][x] !== 'SAND') { // prefer PLAIN
        out[y][x] = 'MOUNTAIN'; break;
      }
    }
  }
  if (!hasForest) {
    for (let tries=0; tries<100; tries++) {
      const x = Math.floor(rnd()*W), y = Math.floor(rnd()*H);
      if (passable(x,y) && base[y][x] !== 'WATER') {
        out[y][x] = (rnd() < 0.5) ? 'FOREST01' : 'FOREST02'; break;
      }
    }
  }
  return out;
}

